module.exports = __webpack_public_path__ + "media/src/images/favicon-7d1ed61577c29165630992cf3d9b914a.ico";